import { Box, Typography, useMediaQuery, useTheme } from '@mui/material'
import { FC } from 'react'
import { useSelector } from 'react-redux'
import { Table } from '../../../../../components/table'
import { TechGrantSelectors } from '../../../../../store/technology'
import { AgencyTag } from '../../../../Projects/subComponents/Project/sharedComponents/AgencyTag'
import { LikeDislikeWidget } from '../../Shared'
import { TablePaging } from './TablePaging'

const TableHeader = ['Grant name', 'Funding agency', 'Amount', 'Project', 'Due date', 'Accept/Reject']

interface MatchesTableProps {
  handleGrantDetailSlideOut: (projectId:string, refId: string) => void
  fetchGrants:() => void
}

export const MatchesTable:FC<MatchesTableProps> = ({ fetchGrants ,handleGrantDetailSlideOut}) => {
  const theme = useTheme()

  const mobileView = useMediaQuery(theme.breakpoints.down('sm'))

  const grants = useSelector(TechGrantSelectors.makeGrantsSummary)

  const filterHeader = mobileView ? TableHeader.slice(0,3) : TableHeader

  const headerCells = filterHeader.map((header, index) => {
    return {
      content: (
        <Typography key={index} color="secondary" fontWeight={500} fontSize="0.9rem">
          {header}
        </Typography>
      ),
    }
  })

  const rows: any[] =
    grants &&
    grants.map((rowCell: any) => {
      const cells = [
        {
          content: (
            <Typography
              color="secondary"
              fontSize="0.875rem"
              fontWeight={theme.typography.fontWeightMedium}
            >
              {rowCell.title}
            </Typography>
          ),
          cellProps: {
            sx: { maxWidth: {xs:250, sm: 300} },
          },
        },
        {
          content: <AgencyTag value={rowCell.agency} />,
        },
        {
          content: (
            <Typography
              fontSize="0.875rem"
              color="secondary.light"
              fontWeight={theme.typography.fontWeightMedium}
            >
              ${rowCell.formattedAwardAmount}
            </Typography>
          ),
        },
        {
          content: (
            <Typography
              fontSize="0.875rem"
              color="secondary.light"
              fontWeight={theme.typography.fontWeightMedium}
            >
              {rowCell.technologyTitle}
            </Typography>
          ),
          cellProps: {
            sx: { display: { xs: 'none', sm: 'table-cell' } },
          },
        },
        {
          content: (
            <Typography
              fontSize="0.875rem"
              color="secondary.light"
              fontWeight={theme.typography.fontWeightMedium}
            >
              {rowCell.closeDate}
            </Typography>
          ),
          cellProps: {
            sx: { display: { xs: 'none', sm: 'table-cell' } },
          },
        },
        {
          content: (
            <LikeDislikeWidget
              cb={fetchGrants}
              key={rowCell._id}
              like={rowCell.like}
              refId={rowCell.refId}
              projectId={rowCell.technologyId}
            />
          ),
          cellProps: {
            sx: { display: { xs: 'none', sm: 'table-cell' } },
          },
        },
      ].filter(Boolean)

      return {
        rowProps: {
          onClick: () => {
            handleGrantDetailSlideOut(rowCell.technologyId, rowCell.topicId)
          },
          sx: {
            background: 'white',
            '&:hover': { cursor: 'pointer', background: theme.palette.grey[100] },
          },
        },
        cells,
      }
    })

  return (
    <Box>
      <Table
        containerProps={{
          sx: {
            width: '100%',
            boxShadow: 'none',
            background: 'transparent',
          },
        }}
        head={{
          containerProps: {
            sx: { borderRadius: '8px', background: theme.palette.grey[200], width: '100%' },
          },
          rows: [{ cells: headerCells || [] }],
        }}
        body={{ rows }}
      />

      <TablePaging />
    </Box>
  )
}
